<template>
  <span style="text-align:left;">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-textarea
        v-bind:value="preLoad(value)"
        v-on:input="event => $emit('input', preUpdate(event))"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
        auto-grow
        :rows="getComponentParam('autoh') ? 1 : 3"
        :autofocus="getComponentParam('autofocus') ? true : false"
        background-color="#fcfcfc"
      ></v-textarea>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <div
        class="text-xs-left:list"
        v-html="displayvalue ? htmlEntities(displayvalue).replace(/\n/g, '<br/>') : ''"
      ></div>
    </template>

    <template v-if="modo == 'filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:keyup.enter="onEnter"
        v-on:input="event => $emit('input', preUpdateFiltro(event))"
        background-color="#fcfcfc"
      ></v-text-field>
    </template>
  </span>
</template>

<script>
try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {};
  },
  methods: {

     htmlEntities(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
},

    preLoad(myval) {
      return myval;
    },
    preUpdate(myval) {
      return myval;
    },
    preLoadFiltro(myval) {
      return myval;
    },
    preUpdateFiltro(myval) {
      return myval;
    }
  }
};
</script>

<style scoped></style>
